import Image from 'next/image'
import { Pop } from '../../animation/animation'

import CSS from './podcast.module.css'


export const Podcast = ({ data }) => {
    return (
        <Pop>
            <article key={data.id} className={CSS.layout}>
                <section>
                    {
                        data.thumbnail &&
                        <Image className={CSS.thumbnail} src={data.thumbnail} alt="" width={200} height={200} unoptimized />
                    }
                </section>

                <section className={CSS.content}>
                    <div>
                        <p className="fs-5 fw-600 c-white">{data.title}</p>
                        
                        {
                            data.date &&
                            <p className="fs-sm c-accent mt-xxs">{new Date(data.date).toLocaleDateString('en-GB')}</p>
                        }
                        
                        {/* {
                            data.description &&
                            <p className="mt-xs">{data.description}</p>
                        } */}
                    </div>
                    
                    <div>
                        {
                            (data.audio || data.link) &&
                            <p className="mt-sm">
                                <Pop inline delay={.15}>
                                    <a className={CSS.button} href={data.audio || data.link} target="_blank" rel="noreferrer">Listen to episode</a>
                                </Pop>
                            </p>
                        }
                    </div>
                </section>

            </article>
        </Pop>
    )
}


